import { ReactElement } from 'react';

import { Badge } from 'components/elements/badge/badge';
import { BadgeType } from 'components/elements/badge/types';
import IconChecked from 'components/icons/checked';
import IconCross from 'components/icons/cross';
import IconDash from 'components/icons/dash';
import IconRefresh from 'components/icons/refresh';

import { ChargesStatus } from 'types/pwcOrder';

import { badgePropsMap } from './keys';
import { BadgeContent } from './styles';

interface StatusBadgeProps {
  status: ChargesStatus | null;
}

const badgeToIconMap: Record<ChargesStatus, ReactElement | null> = {
  [ChargesStatus.SUBMITTED]: <IconRefresh />,
  [ChargesStatus.CONFIRMED]: <IconRefresh />,
  [ChargesStatus.COMPLETED]: <IconChecked />,
  [ChargesStatus.CANCELED]: <IconCross />,
  [ChargesStatus.DECLINED]: <IconCross />,
  [ChargesStatus.FAILED]: <IconCross />,
};

const badgeTypeMap: Record<ChargesStatus, BadgeType> = {
  [ChargesStatus.SUBMITTED]: BadgeType.Default,
  [ChargesStatus.CONFIRMED]: BadgeType.Default,
  [ChargesStatus.COMPLETED]: BadgeType.Success,
  [ChargesStatus.CANCELED]: BadgeType.Fail,
  [ChargesStatus.DECLINED]: BadgeType.Fail,
  [ChargesStatus.FAILED]: BadgeType.Fail,
};

export const ChargeStatusBadge = ({ status }: StatusBadgeProps) => {
  if (!status) {
    return <IconDash />;
  }

  const { type, label } = badgePropsMap[status];
  const icon = badgeToIconMap[type];
  const badgeType = badgeTypeMap[type];

  const usedLabel = label || <IconDash />;

  return (
    <Badge type={badgeType}>
      <BadgeContent>
        {icon}
        {usedLabel}
      </BadgeContent>
    </Badge>
  );
};
